/** 운영 ManageHeader 채팅 배지 갱신 */
export const OPS_CHAT_ATTENTION_EVENT = "evaluator-chat-ops-attention";

/** 웹 푸시 구독 켜짐/꺼짐 — 헤더 폴링 간격 재계산 */
export const OPS_CHAT_PUSH_SUB_EVENT = "evaluator-chat-push-sub";

export type OpsChatAttentionDetail = {
  /** 있으면 헤더가 fetch 없이 점만 맞춤 */
  hasAttention?: boolean;
};

export function notifyOpsChatAttentionRefresh(hasAttention?: boolean) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(OPS_CHAT_ATTENTION_EVENT, {
      detail: { hasAttention } satisfies OpsChatAttentionDetail,
    }),
  );
}

export function notifyOpsChatPushSubChanged(subscribed: boolean) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(OPS_CHAT_PUSH_SUB_EVENT, { detail: { subscribed } }),
  );
}
